var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{ref:"dialog",attrs:{"persistent":_vm.persistent},on:{"hide":function($event){return _vm.$emit('cancel')}}})}
var staticRenderFns = []

export { render, staticRenderFns }